<template>
    <div class="slider normalwidth">

        <div class="slides" :style="{height:firstSlideHeight +'px'}">

            <transition v-on:enter="enterImg">
                <div class="img" v-for="(e,index) in b.element" v-if="slide===index" :key="index">
                    <img :src="e.bild.sizes.large" alt="">
                </div>

            </transition>
        </div>
        <div class="menu">

            <div class="arrow" @click="back" :class="{'active':!atStart}">
                <img :src="require('@/assets/arrowcircle.svg')" alt="">
            </div>
            <div v-for="(e,index) in b.element" class="point"
                 @click="go(index)" :class="{'active':slide===index}">
            </div>
            <div class="arrow" @click="forward" :class="{'active':!atEnd}">
                <img :src="require('@/assets/arrowcircle.svg')" alt="" style="transform:rotate(180deg)">
            </div>
        </div>

        <div class="sub">
            <div v-for="(e,index) in b.element" v-html="e.unterschrift" style="opacity: 0;" v-if="slide===index"></div>
            <transition v-on:enter="enterSub">
                <div v-for="(e,index) in b.element" :key="index" v-if="slide===index" class="text"
                     v-html="e.unterschrift">
                    {{}}

                </div>
            </transition>
        </div>
    </div>
</template>
<script>
    import Velocity from "velocity-animate";

    export default {
        Velocity,
        name: "Slider",
        data() {
            return {
                slide: 0,
                direction: 1
            }
        },
        props: {b: Object},
        computed: {
            firstSlideHeight() {
                return this.b.element[0].bild.sizes["large-height"];
            },
            atStart: function () {
                return this.slide === 0;
            },
            atEnd: function () {
                return this.slide === this.b.element.length - 1;
            },
        },
        watch: {
          slide() {
              console.log(this.$el.querySelector('.sub'))


              this.$el.querySelector('.slides').scrollIntoView({behavior: "smooth"})

          }
        },
        methods: {
            forward() {
                this.direction = 1
                if (!this.atEnd) this.slide++;
            },
            back() {
                this.direction = -1
                if (!this.atStart) this.slide--;
            },
            enterImg(el, done) {
                let img = el.querySelector('img')
                img.velocity({
                    // transform: ['translateX(0)', 'translateX(-100%)'],
                    opacity: [1, 0],
                    transform: ['translateX(0)', 'translateX(' + 10 * this.direction + '%)'],
                    // width: [50 % 0]
                }, {
                    duration: 500,
                    delay: 0
                })
                done()
            },
            enterSub(el, done) {

                el.velocity({
                    // transform: ['translateX(0)', 'translateX(-100%)'],
                    opacity: [1, 0],
                }, {
                    duration: 500,
                    delay: 0
                })
                done()
            },
            go(index) {
                this.direction = index < this.slide ? -1 : 1
                return this.slide = index;
            }
        }
    }
</script>
<style scoped lang="scss">
    .slider {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .arrow {
        opacity: 0.5;

        &.active {
            opacity: 1;
            cursor: pointer;
        }
    }

    .menu {
        display: flex;
        align-items: center;
        width: 100%;
        max-width: 600px;

        justify-content: space-around;
        margin: 32px 0;
    }

    .point {
        width: 8px;
        height: 8px;
        background-color: $zzgray;
        cursor: pointer;

        &.active {
            background-color: $zzcolor;
        }
    }

    .slides {
        //padding-top: 100px;
        /*max-height: 600px;*/
        width: 100%;
        @include mobile {
            min-height: 300px!important;
            height: auto!important;
        }
    }

    .img {
        max-width: 100%;
        max-height: 100%;
        padding: 0 30px;
        /*max-height: 600px;*/
        /*height: 600px;*/

        text-align: center;
        overflow: hidden;

        img {
            max-width: 100%;
            max-height: 100%;
        }
    }

    .sub {
        max-width: 600px;
        text-align: center;

        position: relative;

        .text {
            position: absolute;
            top: 0;
            min-height: 10em;
            @include mobile {
                opacity: 1 !important;
            }
        }
    }
</style>